import { lazy } from 'react';

export default {
  Helmet: lazy(() => import('./Helmet')),
  Comments: lazy(() => import('./pages/Comments')),
  SystemNotifications: lazy(() => import('./pages/SystemNotifications')),
};
